import './AddDashboardModal.css';

import { Button, Grid, MenuItem, TextField, Typography } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import AppLoader from 'components/Loader';
import { Guid } from 'guid-typescript';
import Modal from 'components/ModalWrapper';
import { TrackDashboardAdd } from 'utilities/insights';
import { createDashboard } from 'redux/thunks/dashboard';
import { resetCreatingDashboardSuccess } from 'redux/actions/dashboard';
import { urlHelper } from 'utilities/UrlHelper';
import { useHistory } from 'react-router-dom';

const AddDashboardModal = (props) => {
    const { show, setShow } = props;
    const email = useSelector((state) => state.user.email);
    const userName = useSelector((state) => state.user.userName);
    const siteIds = useSelector((state) => state.site.siteIds);
    const dashboard = useSelector((state) => state.dashboard);

    const [dashboardName, setDashboardName] = useState('');
    const [siteId, setSiteId] = useState('');
    const [error, setError] = useState({ element: '', message: '' });
    const dispatch = useDispatch();
    const history = useHistory();

    useEffect(() => {
        if (dashboard.creatingDashboardSuccess && dashboard.newDashboard) {
            history.push(urlHelper.getDashboardUrl(dashboard.newDashboard.siteId, dashboard.newDashboard.dashboardId));
            dispatch(resetCreatingDashboardSuccess());
        }
    }, [dashboard.creatingDashboardSuccess, history, dispatch, dashboard.newDashboard]);

    const handleSubmit = async (event) => {
        setError({ element: '', message: '' });

        if (!validForm()) {
            return;
        }

        const data = {
            siteId: siteId,
            name: dashboardName,
            owner: userName,
            email: email,
            info: [
                {
                    id: Guid.create().toString(),
                    title: 'Equipment Number',
                    body: '',
                },
            ],
        };

        TrackDashboardAdd(siteId);
        dispatch(createDashboard(data));
    };

    const handleDashboardNameChange = (event) => {
        const id = event.target.value;
        setDashboardName(id);
    };

    const handleSiteIdChange = (event) => {
        const id = event.target.value;
        setSiteId(id);
    };

    const validForm = () => {
        if (!siteId) {
            setError({ element: 'siteId', message: 'You must select a site' });
            return false;
        } else if (!dashboardName) {
            setError({ element: 'dashboardName', message: 'You must enter a name' });
            return false;
        } else if (dashboardName.length < 3) {
            setError({ element: 'dashboardName', message: 'Names must have more than 3 characters' });
            return false;
        }

        return true;
    };

    const isSubmitDisabled = () => {
        if (!siteId) {
            return true;
        } else if (!dashboardName) {
            return true;
        }

        return false;
    };

    return (
        <Modal open={show} height='small' allowClickOutsideToClose onCloseClicked={() => setShow(false)}>
            <Grid container direction='column' className='add-dashboard-modal'>
                <Grid container item justifyContent='center' className='add-dashboard-modal__title'>
                    <Typography variant='h5'>Create a new dashboard</Typography>
                </Grid>
                <Grid container item direction='column' className='add-dashboard-modal__body'>
                    <div className='add-dashboard-modal__body'>
                        {dashboard.creatingDashboard ? (
                            <AppLoader />
                        ) : (
                            <>
                                {siteIds.length === 0 ? (
                                    <div className='add-dashboard-modal__loading-text'>Loading sites... </div>
                                ) : (
                                    <>
                                        <TextField
                                            label='Site'
                                            className='add-dashboard-modal__select'
                                            variant='outlined'
                                            select
                                            value={siteId}
                                            disabled={siteIds.length < 1}
                                            onChange={(e) => handleSiteIdChange(e)}
                                        >
                                            <MenuItem key='empty' value=''>
                                                Select Site...
                                            </MenuItem>
                                            {siteIds.map((siteId) => {
                                                return (
                                                    <MenuItem key={siteId} value={siteId}>
                                                        {siteId}
                                                    </MenuItem>
                                                );
                                            })}
                                        </TextField>
                                    </>
                                )}

                                <div>
                                    <TextField
                                        label='Dashboard'
                                        value={dashboardName}
                                        variant='outlined'
                                        error={error.element === 'dashboardName'}
                                        onChange={(e) => handleDashboardNameChange(e)}
                                        placeholder='Enter the name of your dashboard...'
                                        className='add-dashboard-modal__input'
                                        helperText='* Miniumum 3 characters'
                                    />
                                </div>
                            </>
                        )}
                    </div>
                </Grid>
                <Grid container item justifyContent='space-between' className='add-dashboard-modal__footer'>
                    <Button color='default' size='large' variant='contained' onClick={() => setShow(false)} className='add-dashboard-modal__close'>
                        Close
                    </Button>
                    <Button color='primary' size='large' variant='contained' type='submit' disabled={isSubmitDisabled()} onClick={handleSubmit}>
                        Submit
                    </Button>
                </Grid>
            </Grid>
        </Modal>
    );
};

export default AddDashboardModal;
